export default {
  // 新增工单模板
  add: 'backend.odc.flow.formPage.add',

  // 分页获取工单模板
  page: 'backend.odc.flow.formPage.list.page',

  // 编辑工单模板
  edit: 'backend.odc.flow.formPage.edit',

  // 删除工单模板
  delete: 'backend.odc.flow.formPage.delete',

  // 以层级结构返回所有组织
  organizationTree: 'backend.org.ums.organizationTree.list',

  // 根据组织获取角色列表
  getRoleListByOrgId: 'backend.org.ums.role.getRoleListByOrgId',

  // 新增流程定义
  defineAdd: 'backend.odc.flow.define.add',

  // 分页获取流程定义
  defineList: 'backend.odc.flow.define.page.list',

  // 删除流程定义
  defineDelete: 'backend.odc.flow.define.delete',

  // 查看流程定义
  defineGet: 'backend.odc.flow.define.get',

  // 编辑流程定义
  defineEdit: 'backend.odc.flow.define.edit'
}
